import { useState } from "react";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import Main from "./views/main";
import PromoModal from "./components/PromoModal";

// Rutas de tus imágenes
import promo0 from "./assets/promo/0.jpeg";
import promo1 from "./assets/promo/1.jpeg";
import promo2 from "./assets/promo/2.jpeg";
import promo3 from "./assets/promo/3.jpeg";
import promo4 from "./assets/promo/4.jpeg";

const imagenesAnuncio = [promo0, promo1, promo2, promo3, promo4];

const PrivacyPolicyRedirect = () => {
  useEffect(() => {
    window.location.replace(
      "https://jahir-16-years.my.canva.site/privacy-policy-elite-special-solutions"
    );
  }, []);

  return (
    <div style={{ display: "grid", placeItems: "center", height: "100vh", fontFamily: "sans-serif" }}>
      <p>Redirigiendo a la Política de Privacidad...</p>
    </div>
  );
};
const PrivacyPolicyRedirect0 = () => {
  useEffect(() => {
    window.location.replace(
      "https://jahir-16-years.my.canva.site/terms-conditions-elite-special-solutions"
    );
  }, []);

  return (
    <div style={{ display: "grid", placeItems: "center", height: "100vh", fontFamily: "sans-serif" }}>
      <p>Redirigiendo a la Política de Privacidad...</p>
    </div>
  );
};

function AppContent() {
  const [showBanner, setShowBanner] = useState(true);
  const location = useLocation();

  // Oculta el modal de promoción en la página de política de privacidad
  const isPrivacyPage = location.pathname === "/privacy-policy" || "/terms-conditions-elite-special-solutions";

  return (
    <>
      {!isPrivacyPage && (
        <PromoModal
          isOpen={showBanner}
          onClose={() => setShowBanner(false)}
          images={imagenesAnuncio}
        />
      )}

      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/about-us" element={<Main />} />
        <Route path="/our-expertise" element={<Main />} />
        <Route path="/outsourcing-solutions" element={<Main />} />
        <Route path="/contact" element={<Main />} />
        <Route path="/careers" element={<Main />} />
        
        {/* Ruta para el Webview de Privacy Policy */}
        <Route path="/privacy-policy" element={<PrivacyPolicyRedirect />} />
        <Route path="/terms-conditions-elite-special-solutions" element={<PrivacyPolicyRedirect0 />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}